import { IntroBox } from '@/warranty-v3/components/intro-box';

export function OverviewIntroBox() {
  const detailedContent = (
    <>
      {/* Coverage Section */}
      <section className="space-y-3">
        <h3 className="text-base font-semibold">Coverage Status</h3>
        <div className="rounded bg-gray-50 p-4">
          <p className="leading-relaxed">
            Indicates whether your <strong>supplier's warranty promise</strong>{' '}
            is currently in effect.
          </p>
        </div>
        <ul className="list-inside list-disc space-y-1 pl-5">
          <li>
            <strong>Valid</strong> — Warranty is active; supplier obligations
            remain in effect.
          </li>
          <li>
            <strong>Expired</strong> — Warranty period has ended; obligations
            have lapsed.
          </li>
          <li>
            <strong>Potential Case</strong> — A potential claim scenario has
            been identified.
          </li>
        </ul>
      </section>

      {/* Compliance Section */}
      <section className="mt-6 space-y-3">
        <h3 className="text-base font-semibold">Compliance Status</h3>
        <div className="rounded bg-gray-50 p-4">
          <p className="leading-relaxed">
            Reflects whether your{' '}
            <strong>operation meets required conditions</strong> to uphold the
            warranty.
          </p>
        </div>
        <ul className="list-inside list-disc space-y-1 pl-5">
          <li>
            <strong>Compliant</strong> — All required conditions are met.
          </li>
          <li>
            <strong>Non-Compliant</strong> — One or more conditions have been
            violated.
          </li>
          <li>
            <strong>At Risk</strong> — Conditions are trending toward violation.
          </li>
        </ul>
      </section>
    </>
  );

  return (
    <IntroBox
      title="Coverage Status"
      header="Understanding Warranty Statuses"
      dialogTitle="Warranty Structure Explained"
      dialogDescription="How supplier coverage and operational compliance interact."
      detailedContent={detailedContent}
    >
      refers to the <em>supplier's warranty promise</em> — whether their
      performance obligations remain valid.
      <br />
      <strong>Compliance Status</strong> shows if{' '}
      <em>your operation meets the required conditions</em> to keep that
      coverage intact.
    </IntroBox>
  );
}
